/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum OtpForbiddenCodeEnum {
  "CODE_001" = "CODE_001",

  "CODE_002" = "CODE_002"
}

export type OtpForbiddenCode = t.TypeOf<typeof OtpForbiddenCode>;
export const OtpForbiddenCode = enumType<OtpForbiddenCodeEnum>(
  OtpForbiddenCodeEnum,
  "OtpForbiddenCode"
);
